import { Component } from 'react'
import { observer } from 'mobx-react'

import * as h from 'h'
import { filterRequestsByNamespace } from 'utils'

import KeywordCloud from 'components/KeywordCloud'
import TopBio from './TopBio'
import PublicationsList from './PublicationsList'
import RelatedElements from 'components/Popout/RelatedElements'
import NewsMentions from './NewsMentions'
import ResultsIndicator from 'components/ResultsIndicator'

import styles from './styles.scss'

import { keywordCloudRenderLimit } from 'config'

@observer(['UiStore', 'HuskyTalesStore'])
export default class FacultyProfile extends Component {
  componentDidMount () {
    const { element: faculty } = this.props
    this.props.HuskyTalesStore.fetchFacultyNewsStories(faculty.netid)
  }

  get newsStories () {
    const { HuskyTalesStore: { facultyNewsStories } } = this.props

    return facultyNewsStories
  }

  get isRequestingNewsStories () {
    return filterRequestsByNamespace(this.props.UiStore.requests,
      'storysearch').length > 0
  }

  render () {
    const { element: faculty } = this.props
    const { name, publications, keywords, intellectualProperties } = faculty

    return h.div(h.ca(styles.facultyProfile),
      h.h(TopBio, {
        faculty,
        theme: {
          container: styles.bio,
          name: styles.name,
          title: styles.title,
          department: styles.department,
          email: styles.email,
          profilePicture: styles.profilePicture
        }
      }),
      h.div(h.ca(styles.works),
        h.div(h.ca(styles.keywordNewsMentionsContainer),
          h.h2(h.ca(styles.keywordNewsMentions), `News Mentions`),
          h.h(ResultsIndicator, {
            showProgress: this.isRequestingNewsStories,
            hasResults: this.newsStories
          }),
          h.h(NewsMentions, {
            stories: this.newsStories,
            request: this.isRequestingNewsStories
          })
        ),
        h.h(PublicationsList, {
          publications,
          theme: {
            container: styles.publications,
            list: styles.publicationsList
          }
        }),
        h.div(h.ca(styles.keywordCloudContainer),
          h.h2(h.ca(styles.keywordCloudHeading), `Keywords`),
          h.h(KeywordCloud, {
            name: name,
            keywords: keywords.slice(0, keywordCloudRenderLimit),
            height: 400,
            theme: { container: styles.keywordCloud },
            renderDelay: 300
          })
        ),
        h.div(h.ca(styles.projectWrapper),
          h.div(h.ca(styles.projectContainer),
            h.h(RelatedElements, {
              title: 'Intellectual Properties',
              elements: intellectualProperties,
              small: true
            }))
        )
      )
    )
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/FacultyView/index.js